import React from 'react'
import {config} from '../config'

const TeamStandingsTeamRecord = ({check_angler_name,check_angler_total,check_measurement_type,check_length_measurement_symbol,check_weight_measurement_symbol,check_team_angler_totals}) => {
  
 //console.log('Angler name passed::',check_angler_name);
 //console.log('Angler total passed::',check_angler_total);
 //console.log('Measurement_type passed::',check_measurement_type);

 var check_individual_total = '';

 if(check_team_angler_totals != '' && check_team_angler_totals !== null){
    console.log('Individual level angler totals passed::',typeof(check_team_angler_totals),check_team_angler_totals,check_angler_name);

    //console.log('Individual level angler totals passed::', Object.keys(check_team_angler_totals));

    
    Object.keys(check_team_angler_totals).map(function(k) {

      console.log('Individual key value  passed::', k);

      if(k === check_angler_name){
        check_individual_total = check_team_angler_totals[k].join(" - ");
        
      }
      
    });
    

   
 }


 if(check_measurement_type === 'length'){

  if(check_team_angler_totals != '' && check_team_angler_totals !== null){
    return (
      <td className="center">
  
        <div className="team-angler-name">{check_angler_name}</div>
        <div className="team-sub-total">{check_angler_total}{check_length_measurement_symbol}</div>
        <div className="team-individual-sub-total"> {check_individual_total} </div>
      </td>
  
    )
  }else{
    return (
      <td className="center">
  
        <div className="team-angler-name">{check_angler_name}</div>
        <div className="team-sub-total">{check_angler_total}{check_length_measurement_symbol}</div>
      </td>
  
    )    
  }


 }else{

  if(check_team_angler_totals != '' && check_team_angler_totals !== null){
    return (
      <td className="center">
  
        <div className="team-angler-name">{check_angler_name}</div>
        <div className="team-sub-total">{check_angler_total}{check_weight_measurement_symbol} </div>
        <div className="team-individual-sub-total"> {check_individual_total} </div>
      </td>
  
    )
  }else{
  
    return (
      <td className="center">
  
        <div className="team-angler-name">{check_angler_name}</div>
        <div className="team-sub-total">{check_angler_total}{check_weight_measurement_symbol} </div>
  
      </td>
  
    )

  }

 }

}

export default TeamStandingsTeamRecord